import facebookLogo from "@Icons/facebook.svg";
import instagramLogo from "@Icons/instagram.svg";
import linkedinLogo from "@Icons/linkedin.svg";
import pinterestLogo from "@Icons/pinterest.svg";
import twitterLogo from "@Icons/twitter.svg";
import { FaqLinks, LinkByLocales, SocialLinkByLocales } from "@Types/links";

export const cartLink = `/cart`;
export const cheerzLiveLink = `/products/cheerz-live-photo-booth`;
export const draftsLink = `/dashboard/drafts`;
export const giftLink = `/categories/gift-ideas`;
export const memoryBoxLink = `/product_subscriptions/memory-prints`;
export const ordersLink = `/orders`;
export const profileLink = `/dashboard/profile`;
export const referralsLink = `/dashboard#/referrals`;

export const joinUsLink = "https://cheerz.welcomekit.co/";
export const originBlogLink = "https://royal.cheerz.com";
export const originFaqLink = "https://support.cheerz.com/hc";

export const commitmentsLinks: LinkByLocales = {
  en: "https://www.cheerz.com/en/categories/our-commitments",
  es: "https://www.cheerz.com/es/categories/nuestros-compromisos",
  fr: `${originBlogLink}/inspire/nos-engagements`,
  it: "https://www.cheerz.com/it/categories/responsabilita-sociale",
};

export const homeFaqLink: LinkByLocales = {
  en: `${originFaqLink}/en-us`,
  es: `${originFaqLink}/es`,
  fr: `${originFaqLink}/fr`,
  it: `${originFaqLink}/it`,
};

export const newRequestLink: LinkByLocales = {
  en: `${homeFaqLink.en}/requests/new`,
  es: `${homeFaqLink.es}/requests/new`,
  fr: `${homeFaqLink.fr}/requests/new`,
  it: `${homeFaqLink.it}/requests/new`,
};

export const faqLinks: FaqLinks = {
  delivery: {
    en: `${homeFaqLink.en}/categories/115001947647-Delivery`,
    es: `${homeFaqLink.es}/categories/115001947647-Entrega`,
    fr: `${homeFaqLink.fr}/categories/115001947647-Livraison`,
    it: `${homeFaqLink.it}/categories/115001947647-Consegna`,
  },
  payment: {
    en: `${homeFaqLink.en}/sections/4417716344209-My-payments`,
    es: `${homeFaqLink.es}/sections/4417716344209-Mis-pagos`,
    fr: `${homeFaqLink.fr}/sections/4417716344209-Mes-paiements`,
    it: `${homeFaqLink.it}/sections/4417716344209-Miei-pagamenti`,
  },
};

export const fscLinks: LinkByLocales = {
  en: "https://www.cheerz.com/fsc-certification",
  es: "https://www.cheerz.com/nuestra-certificacion-fsc",
  fr: `${originBlogLink}/inspire/header-inspire/notre-certification-fsc/`,
  it: "https://www.cheerz.com/certificazione-fsc",
};

export const neutralCarbonLink = `${originBlogLink}/profiter/header-profiter/carbon-neutral`;

export const socialLinks: SocialLinkByLocales[] = [
  {
    name: "Facebook",
    src: facebookLogo,
    url: {
      en: "http://www.facebook.com/cheerz.eu",
      es: "http://www.facebook.com/cheerz.es",
      fr: "http://www.facebook.com/cheerz.fr",
      it: "http://www.facebook.com/cheerz.it",
    },
  },
  { name: "Instagram", src: instagramLogo, url: { world: "https://instagram.com/cheerz/" } },
  {
    name: "Twitter",
    src: twitterLogo,
    url: {
      en: "https://twitter.com/cheerz_uk",
      es: "https://twitter.com/cheerz_es",
      world: "https://twitter.com/cheerzto",
    },
  },
  { name: "Pinterest", src: pinterestLogo, url: { world: "https://www.pinterest.com/cheerzto/" } },
  {
    name: "Linkedin",
    src: linkedinLogo,
    url: { world: "https://www.linkedin.com/company/cheerzofficial/" },
  },
];

export const getConfidentialityLink = (locale: string): string =>
  `https://www.cheerz.com/${locale}/privacy-policy`;

export const getTermsLink = (locale: string): string =>
  `https://www.cheerz.com/${locale}/terms-and-conditions`;
